import React, { FC } from 'react';
import './Spinner.css';
import buildClassName from '../../../utils/buildClassName';
const Spinner: FC<{
  color?: 'blue' | 'white' | 'black' | 'bgPrimary' | 'gray';
  withBackground?: boolean;
  style?: object
}> = ({ color = 'white', withBackground, style }) => {
  return (
    <div
      style={style}
      className={buildClassName(
        'Spinner',
        color,
        withBackground && 'with-background',
      )}
    >
      <div />
    </div>
  );
};

export default Spinner;
